/**
 * Pre-defined HR Screening Question Suggestions
 * Common questions that can be quickly added via chips
 */

export interface SuggestionChip {
  id: string;
  text: string;
  category: 'salary' | 'availability' | 'experience' | 'location' | 'work_auth' | 'general';
}

export const HR_SCREENING_SUGGESTIONS: SuggestionChip[] = [
  {
    id: 'salary-1',
    text: 'What is your current CTC?',
    category: 'salary',
  },
  {
    id: 'salary-2',
    text: 'What are your expected CTC?',
    category: 'salary',
  },
  {
    id: 'availability-1',
    text: 'If on notice period, what is the last working day?',
    category: 'availability',
  },
  {
    id: 'availability-2',
    text: 'Are you available for full-time work?',
    category: 'availability',
  },
  {
    id: 'availability-3',
    text: 'Can you work in [timezone]?',
    category: 'availability',
  },
  {
    id: 'work_auth-1',
    text: 'Are you authorized to work in [country]?',
    category: 'work_auth',
  },
  {
    id: 'location-1',
    text: 'What is your current location?',
    category: 'location',
  },
  {
    id: 'location-2',
    text: 'What is your preferred work type (remote/onsite/hybrid)?',
    category: 'location',
  },
  {
    id: 'experience-3',
    text: 'Do you have any professional certifications?',
    category: 'experience',
  },  
  {
    id: 'experience-4',
    text: 'What is the relevant experience?',
    category: 'experience',
  },
  {
    id: 'general-2',
    text: 'Are you currently employed?',
    category: 'general',
  },

  {
    id: 'general-3',
    text: 'Who is your current employer?',
    category: 'general',
  },
  {
    id: 'general-4',
    text: 'What is the reason for change?',
    category: 'general',
  },
];

/**
 * Get suggestions by category
 */
export const getSuggestionsByCategory = (category: SuggestionChip['category']): SuggestionChip[] => {
  return HR_SCREENING_SUGGESTIONS.filter(suggestion => suggestion.category === category);
};

/**
 * Get all categories
 */
export const getAllCategories = (): SuggestionChip['category'][] => {
  return Array.from(new Set(HR_SCREENING_SUGGESTIONS.map(s => s.category)));
};

